export const amenityIconMap: Record<string, string> = {
  // General
  aircon: "AirVent",
  alarmsystem: "ShieldAlert",
  bathtub: "Bath",
  builtinrobes: "Archive",
  dishwasher: "Utensils",
  ductedcooling: "Fan",
  ductedheating: "Flame",
  evaporativecooling: "Wind",
  floorboards: "Layers",
  gasheating: "Flame",
  gym: "Dumbbell",
  hydronicheating: "Thermometer",
  insidespa: "Waves",
  intercom: "Bell",
  laundry: "WashingMachine",
  openfireplace: "Flame",
  petfriendly: "PawPrint",
  remotegarage: "Wrench",
  reversecycleaircon: "RefreshCcw",
  secureparking: "ParkingCircle",
  separatediningroom: "Utensils",
  smokers: "Cigarette",
  splitsystemaircon: "AirVent",
  splitsystemheating: "Flame",
  study: "BookOpen",
  vacuumsystem: "Wind",
  workshop: "Hammer",

  // Exterior
  balcony: "Building",
  courtyard: "TreePine",
  deck: "Layout",
  fullyfenced: "Fence",
  garden: "Flower",
  outdoorent: "PartyPopper",
  outsidespa: "Waves",
  poolaboveground: "Waves",
  poolinground: "Waves",
  shed: "Home",
  tenniscourt: "Activity",

  // Location
  cityviews: "Building2",
  groundfloor: "ArrowDownToLine",
  northfacing: "Compass",
  waterviews: "Droplets",

  // Eco
  ceilinginsulation: "Home",
  doubleglazedwindows: "Square",
  energyefficientappliances: "Zap",
  greywatersystem: "Recycle",
  solarhotwater: "Sun",
  solarpanels: "Sun",
  wallinsulation: "Home",
  waterefficientappliances: "Droplet",
  waterefficientfixtures: "Droplet",
  watertank: "Database",

  // Services
  broadband: "Wifi",
  gas: "Flame",
  paytv: "Tv",

  // Agriculture / extended
  pig: "PiggyBank",
  poultry: "Egg",

  horticulture: "Sprout",
  viticulture: "Grape",
  irrigation: "Droplet",
  grazing: "Leaf",
  cropping: "Scissors",
  aquaculture: "Fish",

  grainsilo: "Database",
  dairy: "Milk",
  abattoirs: "PocketKnife",
  truckdepot: "Truck",
  railyards: "Train",

  primaryschool: "School",
  secondaryschool: "School",
  tertiaryschool: "GraduationCap",
  primaryschoolbus: "Bus",
  secondaryschoolbus: "Bus",
  tertiaryschoolbus: "Bus",

  machineryshed: "Warehouse",
  shearingshed: "Scissors",
  silos: "Database",
  managersaccom: "Home",
  otherhousing: "Home",

  water: "Droplets",
};


  export const iconAliasMap: Record<string, string> = {
    // duplicates (same meaning, different keys)
    isfloorboards: "floorboards",
    isinternallaundry: "laundry",
    isworkshop: "workshop",
    iswatertank: "watertank",
    istenniscourt: "tenniscourt",
  
    // cropping / land use overlaps
    cropishorticulture: "horticulture",
    cropisviticulture: "viticulture",
  
    // livestock
    islivestockcattle: "cattle",
    islivestocksheep: "sheep",
    islivestockhorses: "horse",
    islivestockpigs: "pig",
    islivestockpoultry: "poultry",
  
    // water supplies → unified
    iswaterbores: "water",
    iswatercreeks: "water",
    iswaterdams: "water",
    iswaterriver: "water",
    iswatersprings: "water",
    iswaterwell: "water",
    iswatertown: "water",
  
    // pastures
    yardissheep: "sheep",
    yardiscattle: "cattle",
  };

  export const normalizeIcon = (icon: string) =>
    icon.toLowerCase().replace(/^(is|cropis|yardis)/, "");